module.exports = __webpack_public_path__ + "static/emma-3999881162e19eb6319ed13497066197.png";